import { useEffect, useRef } from "react";

export const useDidMount = (func: () => void): void => {
  const fn = useRef(func);

  useEffect(() => {
    if (fn.current) {
      fn.current();
    }
  }, []);
};
